export default __webpack_public_path__ + "static/media/FriskybunniesWebsite.34be0f57.png";